export interface MatchDayModel {
  id: number;
  defaultDateTime: Date;
  name: string;
  number: number;
}

export const emptyMatchDayModel: MatchDayModel = {
  id: 0,
  defaultDateTime: new Date(),
  name: '',
  number: 0,
};
